'use client';

import { useTranslations, useLocale } from 'next-intl';
import { usePathname, Link } from '@/i18n/routing';
import { LocaleCode } from '@/i18n/locales';
import { useSearchParams } from 'next/navigation';
import { DropdownMenu } from '@/shared/components/primitives/dropdown-menu';
import { LANGUAGES } from '@/shared/constants/languages';
import { cn } from '@ecom/helper-react-class-combine';

export const LanguageSwitcher = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const currentLocale = useLocale() as LocaleCode;

  const t = useTranslations('Home.header.languages');

  const queryString = searchParams.toString();
  const href = queryString ? `${pathname}?${queryString}` : pathname;

  const languagesWithTranslations = LANGUAGES.map((language) => {
    const isActive = language.value === currentLocale;
    return {
      value: language.value,
      isActive,
      activeClassName: 'text-primary',
      label: (
        <Link
          href={href}
          locale={language.value}
          className={cn('w-full px-2 py-1 text-sm', isActive && 'font-body-bold')}
        >
          {t(language.labelKey)}
        </Link>
      ),
    };
  });

  return (
    <DropdownMenu
      items={languagesWithTranslations}
      ariaLabel={t('selectLanguage')}
      menuTitle={t(`${currentLocale}`)}
      className='px-1'
      withArrow
    />
  );
};
